module.exports = __webpack_public_path__ + "assets/img/IMG018.ece4ba49.png";